import classNames from 'classnames'
import { observer } from 'mobx-react-lite'

import style from './Input.module.scss'

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const InputComponent = observer((props: IProps) => {
    const { className, ...rest } = props
    return <input className={classNames(className, style.container)} {...rest} />
})
